import { atom } from 'recoil';
import {
  ITimelineCommentSetting,
  defaultTimelineCommentSetting,
} from '@typings/setting/timelineSetting.interface';

/**
 * 타임라인 댓글 옵션 설정 전역 상태
 * 앱 초기화 시 한 번만 로드되어 서버 부담을 최소화합니다.
 */
export const timelineCommentSettingState = atom<ITimelineCommentSetting>({
  key: 'timelineCommentSettingState',
  default: defaultTimelineCommentSetting,
});

/**
 * 타임라인 댓글 설정 로드 완료 여부
 */
export const timelineCommentSettingLoadedState = atom<boolean>({
  key: 'timelineCommentSettingLoadedState',
  default: false,
});





